var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_c('thead',[_c('tr',_vm._l((Object.keys(_vm.value[0])),function(name){return _c('th',[_vm._v(_vm._s(_vm.getValueName(name)))])}),0)]),_c('tbody',_vm._l((_vm.value),function(item){return _c('tr',_vm._l((Object.values(item)),function(text){return _c('td',[_vm._v(_vm._s(text||0))])}),0)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }